export default __webpack_public_path__ + "static/media/sticker-0.959490e9.png";